export default {
  yc_customer_case_info: '/operate/yc_customer_case_info', // 获取客户案例详情
  yc_customer_case_list: '/operate/yc_customer_case_list', // 获取客户案例
  // YC_CUSTOMER_CASE_INFO: '/api/operate/yc_click_browse_history', // 获取客户案例详情
  yc_advertising_list: '/operate/yc_advertising_list', // 获取广告列表
  yc_product_dynamic_list: '/operate/yc_product_dynamic_list', // 获取产品动态
  yc_product_dynamic_info: '/operate/yc_product_dynamic_info', // 获取产品动态详情
  customersInfo: '/apply_store/customersInfo', // 客户对象信息
  getQuickMenuAllList: '/elebuys/right/v2/menu/getQuickMenuAllList', // 获取快捷菜单入口
  getUsageQuickMenuList: '/elebuys/right/v2/menu/getQuickMenuList', // 获取常用快捷菜单入口
  saveQuickMenu: '/elebuys/right/v2/menu/saveQuickMenu', // 保存我的常用入口
  user_follow_customer__list: '/synergy/customer-new/user-follow/list', // 用户关注客户列表
  team_notice_todo_list: '/team_notice/getTmSaleOrderList', // 代办事项列表
  team_notice_set_state: '/team_notice/ajax_set_state', // 设置代办事项状态
  program_list: '/program/new-goods/mall/page', // 方案列表
  daifa_order_list: '/scm/daifa/home-list', // 代发订单列表
  quotation_list: '/psc/quotation/v2/pageList', // 销售报价
};
